{
  "analytics": {
    "title": "Analytics",
    "mobileTitle": "Analytics",
    "landing": {
      "title": "Analytics Overview",
      "description": "Explore insights and reports about your store performance",
      "comingSoon": "Coming Soon",
      "taskStatistics": {
        "title": "Task Analysis",
        "description": "View task trends and completion rates over time"
      },
      "productGaps": {
        "title": "Product Gaps",
        "description": "Analyze out-of-stock products and brands"
      },
      "shelfScanReport": {
        "title": "Shelf Scan Report",
        "description": "Identify anomalies in scan shelf counts"
      }
    },

    "chart": {
      "taskCount": "Task Count",
      "refillTasks": "Refill Tasks",
      "checkTasks": "Check Tasks",
      "checkedTasks": "Checked Tasks",
      "weekend": "Weekend"
    },
    "error": {
      "title": "Error Loading Analytics",
      "description": "Unable to load analytics data. Please try again later."
    },
    "noData": {
      "title": "No Analytics Data",
      "description": "There is no analytics data available for this store yet."
    },
    "dateRange": {
      "label": "Select date range"
    },
    "storeSelect": {
      "placeholder": "Select stores",
      "noneSelected": "No stores selected",
      "allSelected": "All stores",
      "selectedCount": "{{count}} stores selected",
      "all": "All",
      "none": "None",
      "selectStores": "Select at least one store to view analytics"
    },
    "storeBreakdown": {
      "title": "Store Details for {{date}}",
      "storeName": "Store"
    },
    "shelfScanReport": {
      "title": "Shelf Scan Report",
      "description": "Identify scan anomalies by comparing detected shelf counts",
      "noData": "No shelf scan data available for the selected period",
      "legend": {
        "ok": "OK",
        "warningLight": "Deviation (<10%)",
        "warning": "Anomaly (≥10%)",
        "noData": "No scan",
        "weekend": "Weekend"
      },
      "tooltip": {
        "date": "Date",
        "detected": "Detected",
        "expected": "Expected",
        "previousDay": "Previous scan",
        "shelves": "shelves",
        "ok": "Scan OK",
        "warningLight": "Minor deviation (<10%)",
        "warning": "Significant anomaly (≥10%)",
        "viewScan": "View scan",
        "doubleClickHint": "Double-click to open scan"
      },
      "table": {
        "storeName": "Store",
        "deployDbScanDate": "DeployDB Scandate",
        "expected": "Expected",
        "latest": "Latest",
        "anomalies": "Anomalies",
        "trend": "Trend",
        "notAvailable": "N/A"
      }
    }
  },
  "productFinder": {
    "title": "Store",
    "mobileTitle": "Store",
    "placeholder": "Search for a product or GTIN",
    "searchModeTerm": "Name",
    "searchModeGTIN": "GTIN",
    "noResults": {
      "title": "No products found.",
      "subtitleGtin": "No product could be found for the GTIN {{term}}.",
      "subtitleSearchTerm": "Unfortunately, no matching product was found for the search term \"{{term}}\"."
    },
    "barcodeScanner": {
      "openButton": "Scan GTIN",
      "header": "Scan GTIN",
      "opening": "Opening camera ...",
      "errorOpeningCamera": "Unable to open camera. Please check your permissions and try again.",
      "scanHint": {
        "default": "Align barcode here",
        "unknownGtin": "Unknown GTIN. Please try again.",
        "invalidGtin": "Invalid GTIN. Please try again.",
        "error": "Could not read barcode. Please try again."
      }
    },
    "errors": {
      "invalidGTIN": "Invalid GTIN"
    }
  },
  "storeMap": {
    "title": "Store Map",
    "reset": "Reset",
    "controls": {
      "zoomIn": "Zoom In",
      "zoomOut": "Zoom Out",
      "reset": "Reset Zoom"
    },
    "changeMapOrigin": {
      "DEPLOY_DB": "Switch to Map of Scan",
      "SCAN": "Switch to Map of Deploy DB",
      "UNAVAILABLE": "No Deploy DB map for this store",
      "SINGLE_SCAN": "A single scan always shows its own map"
    },
    "scanMode": {
      "enter": "Show only the latest scan",
      "exit": "Back to the whole day",
      "line": "Scan {{time}} · Route {{route}}",
      "older": "Earlier scan",
      "newer": "Later scan"
    },
    "shelf": {
      "title": "Shelf {{name}}",
      "schematic": "Schematic View",
      "image": "Image View",
      "product": "Product View",
      "productLegacy": "Product View (old)",
      "expandBtn": "Expand Shelf Details",
      "collapseBtn": "Collapse Shelf Details",
      "navigateToLeftNeighbour": "Navigate to left Shelf",
      "navigateToRightNeighbour": "Navigate to right Shelf",
      "noInformationAvailable": "No information available for the products in this shelf.",
      "lastWithProducts": "Last with products: {{date}}",
      "noProductsYet": "No products recorded so far",
      "source": {
        "line": "Data from {{age}} ({{time}})",
        "sameDay": "the selected day",
        "oneDayBefore": "1 day before the selected day",
        "daysBefore": "{{days}} days before the selected day",
        "notCurrent": "Too old to show gaps and prices."
      },
      "unknownFacingHint": "This facing could not be associated with a product.",
      "priceLabel": {
        "gtin": "Price label · GTIN {{gtin}}",
        "noGtin": "Price label · no GTIN read"
      },
      "facingState": {
        "noImage": "Detected, no image",
        "noGtin": "Not detected"
      },
      "errors": {
        "notFound": {
          "title": "Shelf not found",
          "description": "Seems like this shelf does not exist."
        }
      }
    },
    "shelfSearch": {
      "tooltip": "Search for a Shelf",
      "placeholder": "Select a shelf",
      "noIds": "No shelf IDs available",
      "noMatch": "No matching shelf found"
    },
    "layers": {
      "tooltip": "Change Map Layer",
      "headingMapType": "Map Type",
      "headingExtraInfo": "Show Additional Information",
      "mapType": {
        "2d": "2D",
        "3d": "3D",
        "360": "360°"
      },
      "extra": {
        "oos": "OOS",
        "unknown": "Unknown",
        "categories": "Categories",
        "categoriesDebug": "Categories (Debug)",
        "dataAge": "Data age"
      },
      "legendUnknownShare": "Share of shelves with <strong>UNKNOWN</strong> stock levels",
      "legendDataAge": {
        "title": "Age of the data",
        "sameDay": "Selected day",
        "upTo3Days": "1–3 days before",
        "upTo7Days": "4–7 days before",
        "older": "8 days or more before",
        "noData": "No current data"
      }
    },
    "infoPopover": {
      "shelf": "Shelf",
      "category": "Category",
      "shareUnknown": "Share of Unknown Products",
      "noFacings": "No Facings available"
    }
  },
  "todoList": {
    "title": "Tasks",
    "mobileTitle": "Tasks",
    "task": "Task",
    "tabs": {
      "OPEN": "Open Tasks",
      "COMPLETED": "Completed Tasks"
    },
    "no-result": {
      "title": "No Result",
      "no-tasks": "No tasks available.",
      "no-completed-tasks": "No completed tasks available.",
      "no-tasks-filtered": "No tasks available for filter: {{type}}"
    },
    "badges": {
      "ALL": "All",
      "REFILL": "Refill",
      "REFILLED": "Refilled",
      "CHECK": "Check",
      "CHECKED": "Checked",
      "NEW": "New",
      "REORDER": "Reorder",
      "REORDERED": "Reordered",
      "nInStock": "{{n}} in Stock"
    },
    "tasks-description": {
      "OPEN": {
        "CHECK": "Stock or product needs to be checked",
        "REFILL": "Shelf gap needs to be refilled",
        "REORDER": "Product needs to be reordered"
      },
      "COMPLETED": {
        "CHECK": "Stock or product already checked",
        "REFILL": "Shelf gap already refilled",
        "REORDER": "Product already reordered"
      }
    },
    "drawerTitle": "{{count}} Products discovered",
    "filterAndSort": {
      "title": "Filter And Sort",
      "sortBy": "Sort by",
      "filter": "Filter",
      "sortOptions": {
        "newestFirst": "Newest first",
        "oldestFirst": "Oldest first",
        "advertisementsFirst": "Promotional products first",
        "alphabetical": "Alphabetical A-Z",
        "shelf": "Shelf"
      },
      "options": {
        "all": {
          "title": "All",
          "description": "No secondary filtering applied."
        },
        "newTasks": {
          "title": "Show new tasks only",
          "description": "Only tasks that were newly detected in the last scan will be displayed."
        },
        "promotionalProducts": {
          "title": "Show promotional products only",
          "description": "Only current promotional products will be displayed."
        },
        "manualReorders": {
          "title": "Show manual reorders only",
          "description": "Only reorders that need to be placed manually will be displayed."
        }
      }
    },
    "emptyStates": {
      "noTasksToday": "Keine Aufgaben für heute.",
      "noCompletedToday": "You haven't completed any tasks today yet.",
      "allTasksDoneToday": "You've completed all tasks for today!",
      "allTasksDoneInStore": "You've completed all tasks in \"{{category}}\" today!"
    },
    "toasts": {
      "completedError": {
        "title": "Error Completing Task",
        "description": "An error occurred while completing the task. Please try again."
      },
      "reopenError": {
        "title": "Error Reopening Task",
        "description": "An error occurred while reopening the task. Please try again."
      }
    },
    "undo": "Undo"
  },
  "panorama": {
    "title": "Panorama",
    "hint": "Click on a Blue Circle to Start the Panorama-View"
  },
  "storeSelection": {
    "noStores": {
      "title": "No stores available.",
      "subtitle": "You may not be assigned to any store, or no scan has been performed yet."
    },
    "selectStore": {
      "title": "Select a store",
      "searchPlaceholder": "Search for a store",
      "noStoresFound": "No stores found.",
      "noAddress": "No address available"
    },
    "noStoreAccess": {
      "title": "You do not have access to this store or it does not exist.",
      "subtitle": "Please select a valid store from the list.",
      "back": "Back to Store Selection"
    }
  },
  "scanSelection": {
    "noScans": {
      "title": "No scans available.",
      "subtitle": "No scans have been performed for this store yet.",
      "back": "Back to Store Selection"
    },
    "selectScan": {
      "title": "Select a scan to continue",
      "noScansFound": "No scans found."
    },
    "noScansAvailable": {
      "title": "No scans available.",
      "subtitle": "There are no scans available for this store yet.",
      "back": "Back to Store Selection"
    },
    "scanDoesNotExist": {
      "title": "This scan does not exist.",
      "subtitle": "The scan you are looking for could not be found.",
      "back": "Back to the latest scan"
    },
    "latestKeyword": "Latest"
  },
  "account": {
    "title": "Account",
    "mobileTitle": "Account",
    "systemSettings": "System Settings",
    "language": {
      "title": "Select Language",
      "label": "Language",
      "options": {
        "en": "English",
        "de": "German"
      }
    },
    "storeAssignments": {
      "label": "Assigned Stores",
      "noAddressAvailable": "No address available",
      "noAssignmentsHint": "You are not assigned to any stores."
    },
    "store": {
      "title": "Select Store",
      "label": "Store"
    },
    "scan": {
      "title": "Select scan",
      "label": "Scan"
    },
    "version": {
      "label": "App Version"
    },
    "licenses": {
      "label": "Licences",
      "dictionary": "Compound word splitting in the product search uses the German dictionary of jWordSplitter by Daniel Naber (based on Morphy, with additions from LanguageTool), licensed under",
      "source": "Source"
    },
    "logout": "Log Out"
  },
  "signIn": {
    "title": "Sign in to Ubica",
    "description": "We have found several sign-in options for your team. Please choose a sign-in option below to continue.",
    "optionText": "OR",
    "action": "Sign in with"
  },
  "common": {
    "greeting": "Hello {{name}}!",
    "store": "Store",
    "role": "Role",
    "statusLegend": "Status",
    "inStock": "Has Stock",
    "outOfStock": "Out of Shelf",
    "unknownStock": "Unknown",
    "all": "All",
    "loading": "Loading...",
    "close": "Close",
    "back": "Back",
    "select": "Select",
    "next": "Next",
    "noAddress": "No address available",
    "paginationInfo": "{{currentCount}} of {{totalCount}} entries",
    "resultInfo": "{{count}} entries found",
    "loadingStoreData": "Loading your store data...",
    "loadingSignInClients": "Loading sign-in options...",
    "save": "Save",
    "unexpectedError": {
      "title": "Unexpected Error",
      "description": "An unexpected error has occurred. Please try again later."
    },
    "dialog": {
      "confirm": {
        "title": "Confirm Action",
        "action": "Confirm"
      },
      "cancel": "Cancel"
    },
    "datepicker": {
      "placeholder": "Select date",
      "today": "Today",
      "yesterday": "Yesterday",
      "nextMonth": "Next Month",
      "previousMonth": "Previous Month"
    },
    "toast": {
      "close": "Close notification",
      "dismiss": "Dismiss"
    },
    "stock": "Stock",
    "roles": {
      "system": {
        "ADMIN": "Administrator",
        "USER": "User",
        "DEVELOPER": "Developer",
        "VIEWER": "Viewer",
        "CONTRIBUTOR": "Contributor"
      },
      "store": {
        "STORE_MANAGER": "Manager",
        "STORE_EMPLOYEE": "Store Employee",
        "STORE_VIEWER": "Store Viewer"
      }
    },
    "error": {
      "serverError": {
        "message": "An error has ocurred. Please try again later.",
        "action": "Reload page"
      }
    },
    "productBarcodeView": {
      "title": "Scan Barcode",
      "description": "Scan this barcode to find the product in another system.",
      "copyLabel": "Copy GTIN"
    },
    "filepicker": {
      "prompt": "Select or drag & drop a file here",
      "unsupported": "File not supported"
    },
    "accessDenied": {
      "title": "Access Denied",
      "description": "You do not have the necessary permissions to access this page. If you believe this is an error, please contact your administrator.",
      "action": "Go back"
    },
    "newVersion": {
      "title": "New Version available",
      "description": "Please update to the latest version for the best experience.",
      "action": "Refresh now"
    }
  },
  "shelfCategories": {
    "DIAPERS": "Diapers",
    "CLEANING": "Cleaning Products",
    "HEALTH": "Health & Medicine",
    "PET": "Pet Supplies",
    "BABY_FOOD": "Baby Food",
    "HAIR": "Hair Care",
    "PARFUM": "Fragrance & Perfume",
    "TOOTH_BRUSH": "Dental Care",
    "TOILET_PAPER": "Toilet Paper",
    "FOOD": "Food & Groceries",
    "DEO": "Deodorant",
    "SHOWER_GEL": "Shower Gel & Body Care",
    "BEVERAGES": "Drinks",
    "COFFEE": "Coffee",
    "EGGS": "Eggs",
    "PASTA": "Pasta",
    "SWEETS": "Sweets",
    "BONBONS": "Bonbons",
    "HOUSEKEEPING": "Housekeeping"
  },
  "quickSelects": {
    "store": {
      "name": "Quick Store Selection",
      "noAddress": "No address available",
      "redirectedToLatestScan": {
        "title": "Redirected to Latest Scan of Store {{storeName}}",
        "description": "No scan on the {{scanDate}} for Store {{storeName}}. You have been redirected to the latest scan."
      },
      "errorSwitchingStore": {
        "title": "Error switching store",
        "description": "Could not switch the store. Please try again."
      }
    },
    "scan": {
      "name": "Quick Scan Selection",
      "latestPreset": "Latest Scan",
      "previousScanPreset": "Previous Scan",
      "nextScanPreset": "Next Scan"
    },
    "day": {
      "name": "Quick Day Selection",
      "latestPreset": "Latest day",
      "previousPreset": "Previous day",
      "nextPreset": "Next day",
      "lastScan": "Last scan: {{time}}"
    }
  },
  "storeManagement": {
    "title": "Store Management",
    "inventoryUpload": "Upload Inventory Data",
    "date": "Date",
    "upload": "Upload",
    "uploading": "Uploading...",
    "clickHere": "Click to select CSV file",
    "uploadSuccess": "File uploaded successfully!"
  },
  "admin": {
    "title": "Administration",
    "goBack": "Back to App",
    "userManagement": {
      "title": "User Management",
      "subtitle": "Manage user roles and store assignments below.",
      "table": {
        "name": "Name",
        "email": "E-Mail Address",
        "role": "Role",
        "assignments": "Assignments",
        "searchPlaceholder": "Search for a User",
        "loadingUsers": "Loading Users ...",
        "noUsersMatch": "No users match the current search.",
        "noStoreAssignments": "No store assignments",
        "addAssignment": "Add store assignment",
        "removeAssignment": "Remove {{storeName}} assignment",
        "teamMembers": "Team members",
        "usersCount": "{{count}} Users",
        "adminImplicitAccessHint": "Administrators automatically have access to all stores."
      },
      "pagination": {
        "showing": "Showing {{current}} of {{total}} users",
        "loadMore": "Load more"
      },
      "dialog": {
        "addGrant": {
          "title": "Assign store to {{userName}}",
          "description": "Select a store and role to assign to this user.",
          "storeLabel": "Store",
          "storePlaceholder": "Store Name, City, ...",
          "storeLoading": "Loading stores…",
          "roleLabel": "Role",
          "cancel": "Cancel",
          "assign": "Assign",
          "selectStoreHeading": "Select a Store",
          "selectRoleHeading": "Select Role",
          "storeNameColumn": "Store Name",
          "addressColumn": "Address",
          "loadingStores": "Loading stores...",
          "noStoresFoundWithSearch": "No stores found matching your search",
          "allStoresAssigned": "The user is already assigned to all of the available stores",
          "successTitle": "Assignment Successful",
          "successDescription": "{{userName}} was assigned to Store {{storeName}}"
        },
        "confirmRemove": {
          "title": "Remove Grant of {{userName}}",
          "message": "Are you sure you want to remove the assignment of {{userName}} for Store {{storeName}}?",
          "confirm": "Remove",
          "successTitle": "Grant removed successfully",
          "errorTitle": "Failed to remove grant"
        }
      }
    },
    "noAccess": {
      "title": "Administration Access Restricted",
      "description": "You don't have the required administrator permissions to view this page. If you believe this is an error, please contact an administrator.",
      "action": "Go to Store Selection"
    }
  }
}
